import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SrLink from 'client/components/SrLink/SrLink';
import SearchActions from 'client/actions/Search';

class SrSuggestedSearchesSection extends Component {
  static propTypes = {
    suggestedSearchFilters: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  _onClickSuggestedSearch = (event, suggestedSearchFilter) => {
    const { dispatch } = this.props;
    event.preventDefault();
    dispatch(SearchActions.applySuggestedFilter, {
      suggestedSearchFilter,
    });
  }

  render() {
    const { suggestedSearchFilters } = this.props;
    if (!suggestedSearchFilters.length) {
      return null;
    }

    return (
      <div className='suggestedSearchesContainer'>
        <div className='resultsContainer'>
          <div className='results-filter-divider-container clearfix' key='listing-divider'>
            <div className='results-filter-divider' />
          </div>
        </div>
        <span className='headline main'>
          Suggested Searches
        </span>
        <div className='resultsContainer'>
          {suggestedSearchFilters.map((suggestedSearchFilter) => {
            return (
              <div
                className='searchLinkContainer'
                onClick={(e) => this._onClickSuggestedSearch(e, suggestedSearchFilter)}
                key={suggestedSearchFilter.id}
              >
                <div className='searchLinkInnerContainer'>
                  <div className='searchFilterInfo'>
                    <span className='searchFilterDisplayName'>
                      {suggestedSearchFilter.displayName}
                    </span>
                    <span className='searchFilterResults'>
                      {suggestedSearchFilter.resultsCount} homes & apartments
                    </span>
                  </div>
                  <span className='arrow' />
                </div>
              </div>
            );
          })}
          <div className='filters-cta'>
            <span className='magnifying-glass' />
            <div className='filters-link-container'>
              <SrLink
                classname='filters-link'
                to='/search'
              >
                Change your filters
              </SrLink>
            </div>
            <div>
              <span className='filters-subtext'>
                to find more places.
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SrSuggestedSearchesSection.displayName = 'SrSuggestedSearchesSection';

export default SrSuggestedSearchesSection;
